'use strict';

const h = require('phy');

const TraitsError = ({ showError, traitsErrorMsg }) => {
  if (showError) {
    return h(
      'div',
      {
        id: 'variation-error',
        className: 'error icon-circle-alert visible',
        'data-bhw': 'VariationsError',
        'data-bhc': 'error:variations-not-selected',
      },
      traitsErrorMsg
    );
  } else {
    return null;
  }
};

module.exports = TraitsError;
